export function isEmpty(value: any): boolean {
  return (
    value === null ||
    typeof value === "undefined" ||
    value === "" ||
    value.length === 0 ||
    value.size === 0 ||
    (!Array.isArray(value) && typeof value === "object" && Object.keys(value).length === 0)
  );
}

export const sleep = (ms: number): Promise<any> => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

export function notFinite(number: number): boolean {
  return (
    number === null ||
    typeof number === "undefined" ||
    Number.isNaN(number) ||
    !Number.isFinite(number)
  );
}

export function readableTime(ms: number): string {
  if (notFinite(ms)) {
    return "";
  }
  const milliseconds = ms % 1000,
    seconds = Math.floor((ms / 1000) % 60) + milliseconds / 1000,
    minutes = Math.floor((ms / (1000 * 60)) % 60) + seconds / 60,
    hours = Math.floor((ms / (1000 * 60 * 60)) % 24) + minutes / 60;
  const f = (n, digits) => n.toFixed(digits);
  if (hours >= 1) return `${f(hours, 1)} h`;
  if (minutes >= 1) return `${f(minutes, 1)} min`;
  if (seconds >= 1) return `${f(seconds, 1)} s`;
  return `${f(ms, 0)} ms`;
}

export function slurpDirectory(requireContext: any): any[] {
  let result = [];
  requireContext.keys().forEach((filepath) => {
    const module = requireContext(filepath);
    result.push(module);
  });
  return result;
}
